import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=22276ad6&scoped=true&"
import script from "./Accueil.vue?vue&type=script&lang=js&"
export * from "./Accueil.vue?vue&type=script&lang=js&"
import style0 from "./Accueil.vue?vue&type=style&index=0&id=22276ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22276ad6",
  null
  
)

export default component.exports